import BookingItem from 'components/BookingItem'
import Select from 'components/Select'
import { SelectTypes } from 'components/Select/Select.props'
import React, { useEffect, useState } from 'react'
import { useAppDispatch } from 'store'
import { formatAMPM, getHour } from 'utils/generate-times'
import { BookingCourtProps } from './BookingCourt.props'
import {
  BookingCourtContainer,
  BookingCourtDivider,
} from './BookingCourt.styled'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import { useParams } from 'react-router'
import { Location } from 'models/location'
import {
  dataOpenCourtsResponse,
  getOpenCourtsRequest,
  getOpenCourtsResponse,
} from 'services/appointment/appointment.types'
import { unwrapResult } from '@reduxjs/toolkit'
import Spinner from 'components/Spinner'
import { BookingNowData } from 'models/appointment.model'

const BookingCourt = ({ options, date, locationInfo }: BookingCourtProps) => {
  const [bookDay, setBookDay] = useState<Date>(date)
  const [selectedOption, setSelectedOption] = useState<SelectTypes>()
  const [isLoading, setIsLoading] = useState<boolean | undefined>()

  const [courtList, setCourtList] = useState<dataOpenCourtsResponse[]>([])
  const [startRangeTime, setStartRangeTime] = useState<string[]>()
  const [endRangeTime, setEndRangeTime] = useState<string[]>()

  const draftBookingNowData = {
    location_name: '',
    location_logo_url: '',
    date: date,
    start_time: '',
    end_time: '',
    court_id: '',
    court_name: '',
    price: 0,
  }
  const [bookingNowData, setBookingNowData] = useState<BookingNowData>(
    draftBookingNowData
  )

  const dispatch = useAppDispatch()
  const params = useParams<Location>()

  useEffect(() => {
    if (locationInfo) {
      const bookingData = bookingNowData
      bookingData.location_name = locationInfo.name
      bookingData.location_logo_url = locationInfo.logo_url
        ? locationInfo.logo_url
        : ''
      setBookingNowData(bookingData)
    }
  }, [locationInfo])

  useEffect(() => {
    if (selectedOption) {
      handleSelectedOption(date, selectedOption)
    }
    setBookDay(date)
    getDateCourtBookNowData(date, selectedOption)
  }, [date])

  const getDateCourtBookNowData = (date: Date, option?: SelectTypes) => {
    const bookingData = bookingNowData
    bookingData.date = date
    if (option) {
      bookingData.court_id = option.value
      bookingData.court_name = option.label
    }
    setBookingNowData(bookingData)
  }

  const handleSelectedOption = async (date: Date, option: SelectTypes) => {
    getDateCourtBookNowData(date, option)

    setSelectedOption(option)

    const openCourtsParams: getOpenCourtsRequest = {
      locationId: params ? params.locationId : '',
      date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
    }

    if (option.value !== undefined) {
      openCourtsParams.court_id = Number(option.value)
    }

    setIsLoading(true)
    dispatch(appointmentActions.getOpenCourts(openCourtsParams)).then(res => {
      unwrapResult(res)
      const { data } = res.payload as getOpenCourtsResponse
      setCourtList(data)
      updateTimeSlot(data)
    })
  }

  const updateTimeSlot = (data: dataOpenCourtsResponse[]) => {
    const sortedData = data.sort((a, b) =>
      getHour(a.start) > getHour(b.start) ? 1 : -1
    )
    const startRangeList: string[] = [],
      endRangeList: string[] = []
    sortedData.map(data => {
      startRangeList.push(formatAMPM(data.start))
      endRangeList.push(formatAMPM(data.end))
    })
    setStartRangeTime(startRangeList)
    setEndRangeTime(endRangeList)
    setIsLoading(false)
  }

  return (
    <BookingCourtContainer>
      <div style={{ marginLeft: 25 }}>
        <Select
          options={options}
          onChange={selectedOption =>
            handleSelectedOption(bookDay, selectedOption as SelectTypes)
          }
        />
      </div>
      {selectedOption !== undefined && isLoading && <Spinner />}
      {selectedOption !== undefined &&
        !isLoading &&
        startRangeTime &&
        endRangeTime &&
        courtList &&
        courtList.length > 0 &&
        courtList.map((range, index) => (
          <>
            <BookingItem
              allData={range}
              price={range.price}
              bookingNowData={bookingNowData}
              startTime={startRangeTime[index]}
              nextTime={endRangeTime[index]}
              available={range.courts && range.courts.length > 0 ? true : false}
              // bookingByMe={BOOKING_MOCK[index].bookingByMe}
              key={range.court_ids[index]}
            />
            <BookingCourtDivider />
          </>
        ))}
    </BookingCourtContainer>
  )
}

export default BookingCourt
